import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { PIC } from "@ryde/assets";
import {
  DATA_E2E_KEY,
  IRideDto,
  IStyledAttributes,
  useDrawers,
  useHasPermissions,
} from "@ryde/shared";

import { FramerTooltip } from "../tooltips";

const RideJourneyIndicatorWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "ride-journey-indicator-wrapper",
})`
  display: inline-flex !important;
  align-items: center;
  column-gap: 4px;
  cursor: pointer;
`;

interface IRideJourneyIndicator extends Partial<IRideDto> {
  shouldHideIcon?: boolean;
}

const entity = "journey";

export const RideJourneyIndicator: FC<IRideJourneyIndicator> = ({
  journeyId,
  journeyName,
  shouldHideIcon = false,
}) => {
  const { openJourneyEditFormDrawer } = useDrawers();
  const { t } = useTranslation();

  const { hasPermissions: hasJourneyViewPermission } = useHasPermissions({
    entity,
    action: "read",
  });

  const handleJourneyClick = (): void => {
    if (journeyId && hasJourneyViewPermission) {
      openJourneyEditFormDrawer({
        id: journeyId,
      });
    }
  };

  return (
    journeyId && (
      <FramerTooltip
        content={`${t("ride.formLabel.journeyId")} : ${journeyId} | ${journeyName}`}
      >
        <RideJourneyIndicatorWrapper onClick={handleJourneyClick}>
          {!shouldHideIcon && <PIC.JourneySvg className="journey_svg" />}
          {journeyId}
        </RideJourneyIndicatorWrapper>
      </FramerTooltip>
    )
  );
};
